export default "__VITE_ASSET__DkTC5aiI__"